import { combineReducers } from 'redux';

const defaultPriData = null;

const priSettingData = (state = defaultPriData, action) => {
  switch (action.type) {
    case 'SET_PRI_DATA_SUCCESS':
      return { ...action.priSettings };
    default:
      return state;
  }
};

const defaultSipData = null;
const sipSettingData = (state = defaultSipData, action) => {
  switch (action.type) {
    case 'SET_SIP_DATA_SUCCESS':
      return { ...action?.sipSettings };
    default:
      return state;
  }
};

export default combineReducers({
  priSettingData,
  sipSettingData,
});
